


















import {
  defineComponent, ref,
} from '@vue/composition-api';

import absenceLog from '@/table/setting/absenceLog';

import CommonModalWithDriverAbsenceEditor from '@/components/Driver/CommonModalWithDriverAbsenceEditor.vue';

const CommonPanelWithVehicleAbsenceLog = defineComponent({
  components: { CommonModalWithDriverAbsenceEditor },
  props: {
    absenceLogs: { default: () => [] },
  },
  setup() {
    const pendingEditId = ref(-1);

    return {
      absenceLog,
    };
  },
});

export default CommonPanelWithVehicleAbsenceLog;
